import React from 'react';
import './Services.css';
import { AllServices } from '../allServices/allServices';

export function Services() {
  const services = [
    {
      title: "Residential Moving",
      description: "We provide hassle-free residential moving services, ensuring all your belongings are securely packed and transported with care. Relocating to a new home can be stressful, but we’re here to make it seamless. Our trained team carefully handles your belongings, ensuring the utmost care during packing, loading, transit, and unloading. From delicate crockery to heavy furniture, we treat every item as if it were our own.",
      image: "s1.webp", 
    },
    {
      title: "Packing & Unpacking",
      description: "Our professional team takes care of packing and unpacking your items, ensuring everything is organized and damage-free. Effortless packing and unpacking solutions tailored to your needs. Our team uses high-quality, eco-friendly materials to securely wrap your valuables. Once at the destination, we unpack and arrange your items to help you settle in quickly.",
      image: "s2.webp",
    },
    {
      title: "Office Shifting",
      description: "We specialize in efficient and smooth office relocations, minimizing downtime for your business. We minimize downtime with our efficient office relocation services. Our team carefully manages your office equipment, furniture, and documents, ensuring everything reaches the new location intact and organized, ready for immediate setup.",
      image: "s3.webp",
    },
    {
      title: "Commercial Moving",
      description: "Our commercial moving services cater to businesses of all sizes, ensuring a seamless transition. Our commercial moving service caters to businesses of all sizes, from retail stores to warehouses. We plan and execute every step meticulously, ensuring minimal disruption to your business operations.",
      image: "s4.webp",
    },
    {
      title: "AC and TV Uninstalling & Installing",
      description: "We provide professional AC and TV uninstalling and installing services to ensure your devices are safely handled during relocation. Our trained technicians use the best tools and methods to securely uninstall and reinstall your appliances without any damage.",
      image: "s5.webp",
    },
    {
      title: "Storage Solutions",
      description: "Secure storage facilities for your short-term or long-term needs, with 24/7 surveillance. Need extra space during your move? Our secure, climate-controlled storage facilities are the perfect solution. Whether it’s short-term or long-term storage, we keep your items safe and accessible whenever you need them.",
      image: "s6.webp",
    },
  ];

  return (
    <div>
      <h2 className="services-title">Our Services</h2>
      <AllServices />
      <section className="services">
      <div className="services-list">
        {services.map((service, index) => (
          <div 
            key={index} 
            className={`service-item ${index % 2 === 0 ? "text-left" : "text-right"}`}
          >
            <div className="service-text">
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
            <div className="service-image">
              <img 
                src={service.image} 
                alt={`${service.title} service in Gaya, Patna, Ranchi, Delhi by Neha Packers and Movers`} 
                className="responsive-image"
                loading="lazy"
              />
            </div>
          </div>
        ))}
      </div>
    </section>
    </div>
  );
}